import React, { useState, useEffect } from 'react';
import NewNotificationForm from '../components/NewNotificationForm';
import PreviousNotifications from '../components/PreviousNotifications';

import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/NotificationForm.css';

export default function AdminNotifications(props) {
    const [notificationList, setNotificationList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getNotificationList();
   
    }, [])

    function getNotificationList() {  
        setIsLoading(true);  
        //Check if page access is still allowed
        props.onChildUpdate();
        var notificationCount = 10;
        ServiceCalls.getRecentNotifications(notificationCount).then(function (data)  {
            setNotificationList(data);  
            setIsLoading(false);
        });  
    }  

    function disableVisibility() {
        setIsLoading(true);
        ServiceCalls.hideNotification().then(function (data) {        
            getNotificationList();
        });
    }

    const updateNotification = async (notif) => {  
        setIsLoading(true);  
        const notification = { notificationId: notif.notificationId , message: notif.message, severity: notif.severity, audience: notif.audience };  
        try {  
            const data = await ServiceCalls.updateSiteNotification(notification);  
            if(data){  
                getNotificationList();  
                return true;  
            }  
            return false;  
        } catch (error) {  
            console.error("Failed to update notification:", error);  
            return false;  
        }  
    }  
    
    const deleteNotification = async (notif) => {
        setIsLoading(true);
        
        try{
            const isSuccessful = await ServiceCalls.deleteSiteNotification(notif.notificationId);
            if (isSuccessful) {
                getNotificationList();
                return true;
            }
            return false;
        } catch(error) {
            console.error("Failed to delete notification:", error);
            return false;
        }
    }

    const addNotification = () => { 
        setIsLoading(true)      
        getNotificationList();
    }

    return (
        <>
            <NewNotificationForm notificationList={notificationList}  handleDisable={disableVisibility} onNotificationAdded={addNotification} setIsLoading={setIsLoading}/>
            <PreviousNotifications notificationList={notificationList} onNotificationUpdate={updateNotification} onDeleteNotification={deleteNotification} isLoading={isLoading}/>
        </>
    )
}